export default {
  title: 'Hero D'
}

const Template = args => `
  <cradlepoint-hero-d
    title-white-text="${args['title-white-text'] ? args['title-white-text'] : 'The freedom to securely connect your enterprise '}"
    title-yellow-text="${args['title-yellow-text'] ? args['title-yellow-text'] : '— anywhere.'}"
    description="${args['description'] ? args['description'] : 'Connect and protect your people, places, and things with 5G and LTE through Wireless WAN, private network, and cybersecurity solutions.'}"
    background-image="${args['background-image'] ? args['background-image'] : 'https://img.cradlepoint.com/auto-mapping-folder/2023/08/CP-Hero-base-v2.jpg'}"
    background-position="${args['background-position'] ? args['background-position'] : 'center'}"
    background-size="${args['background-size'] ? args['background-size'] : 'cover'}"
    padding-top="${args['padding-top'] ? args['padding-top'] : 0}"
    height="${args['height'] ? args['height'] : '840px'}"
  ></cradlepoint-hero-d>
`;

export const Default = Template.bind({});

Default.args = {
  'title-white-text': 'The freedom to securely connect your enterprise ',
  'title-yellow-text': '— anywhere.',
  'description': 'Connect and protect your people, places, and things with 5G and LTE through Wireless WAN, private network, and cybersecurity solutions.',
  'background-image': 'https://img.cradlepoint.com/auto-mapping-folder/2023/08/CP-Hero-base-v2.jpg',
  'padding-top': 0,
  'background-position': 'center',
  'background-size': 'cover',
  'height': '840px'
}
